var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlockDeclined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 130,
    viewBox: "0 0 109 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.9295 106.699H82.8466V40.4492C82.8466 24.8559 70.2515 12.165 54.7758 12.165C39.3001 12.165 26.7049 24.8559 26.7049 40.4492L26.7049 106.699H14.6221L14.6221 40.4492C14.6221 18.1452 32.6303 0 54.7661 0C76.9019 0 94.9101 18.1452 94.9101 40.4492V106.699H94.9295Z",
    fill: "#A81630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.384 60.5781H6.40224C3.30055 60.5781 0.786133 63.0925 0.786133 66.1942V124.385C0.786133 127.487 3.30055 130.001 6.40224 130.001H103.384C106.486 130.001 109 127.487 109 124.385V66.1942C109 63.0925 106.486 60.5781 103.384 60.5781Z",
    fill: "#E8505B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4532 78.0903C73.0539 79.7145 73.0539 82.348 71.4532 83.9722L43.548 112.288C41.9472 113.912 39.352 113.912 37.7513 112.288C36.1505 110.663 36.1505 108.03 37.7513 106.406L65.6565 78.0903C67.2572 76.4661 69.8525 76.4661 71.4532 78.0903Z",
    fill: "#862B45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3329 78.0903C36.7322 79.7145 36.7322 82.348 38.3329 83.9722L66.2382 112.288C67.8389 113.912 70.4342 113.912 72.0349 112.288C73.6356 110.663 73.6356 108.03 72.0349 106.406L44.1296 78.0903C42.5289 76.4661 39.9336 76.4661 38.3329 78.0903Z",
    fill: "#862B45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockDeclined);
export default __webpack_public_path__ + "static/media/padlockDeclined.abc255ac9462ce89ef922b8d1d99f0b9.svg";
export { ForwardRef as ReactComponent };